import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comment-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 0c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64h-144l-124.9 93.6c-2.2 1.7-4.7 2.4-7.1 2.4-6.2 0-12-4.9-12-12v-84h-96c-35.3 0-64-28.7-64-64v-288c0-35.3 28.7-64 64-64h384zM464 352v-288c0-8.8-7.2-16-16-16h-384c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h144v60l67.2-50.4 12.8-9.6h160c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comment-alt.js
// module id = 1715
// module chunks = 0